import { render, staticRenderFns } from "./付款通知.vue?vue&type=template&id=038d68bc&scoped=true&"
import script from "./付款通知.vue?vue&type=script&lang=js&"
export * from "./付款通知.vue?vue&type=script&lang=js&"
import style0 from "./付款通知.vue?vue&type=style&index=0&id=038d68bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038d68bc",
  null
  
)

export default component.exports